import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { getFilenameFromUrl } from '@/common/helpers/helpers'

import * as Styles from './styles'

const ReturnLabelCheckboxes = ({
  returnLabels,
  returnLabelsChecked,
  onCheckReturnLabel,
  customsDeclarationChecked,
  onCheckCustomsDeclaration,
}) => {
  const { t } = useTranslation()
  const customsDeclarationUrl = returnLabels?.find(label => label.customs_declaration_url)?.customs_declaration_url

  if (!returnLabels?.length) return null

  const isReturnLabelChecked = returnLabelId => {
    return !!returnLabelsChecked?.find(id => id === returnLabelId)
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Etiquetas de envío')}</Text>
      <Styles.CheckboxContainer>
        {returnLabels.map((returnLabel, index) => (
          <Checkbox
            key={index}
            checked={isReturnLabelChecked(returnLabel.id)}
            label={getFilenameFromUrl(returnLabel.label_url)}
            onChange={() => onCheckReturnLabel(returnLabel.id)}
          />
        ))}
        {customsDeclarationUrl && (
          <Checkbox
            label={getFilenameFromUrl(customsDeclarationUrl)}
            checked={customsDeclarationChecked}
            onChange={e => onCheckCustomsDeclaration(e.target.checked)}
          />
        )}
      </Styles.CheckboxContainer>
    </Styles.Container>
  )
}

export default ReturnLabelCheckboxes
